import { render, staticRenderFns } from "./AbandonedOrdersReport.vue?vue&type=template&id=3d663882&"
import script from "./AbandonedOrdersReport.vue?vue&type=script&lang=js&"
export * from "./AbandonedOrdersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports